import React from 'react';
import { ApolloProvider } from '@apollo/client';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import './custom.scss';
import AdminRouter from './admin_screens/route';
import client from './config/graphql';
import ErrorBoundary from './components/ErrorBoundary';

const App = () => (
  <ErrorBoundary>
    <ApolloProvider client={client}>
      <div className="">
        <AdminRouter />
      </div>
    </ApolloProvider>
  </ErrorBoundary>
);

export default App;
